const f = {
  color: {
    wrapper: {
      border: "#abb9c7ff",
      text: "#abb9c7ff"
    },
    icon: "#7e8e9eff",
    background: "#ffffffff",
    input: {
      text: "#314351ff",
      placeholder: "#abb9c7ff"
    },
    listItem: {
      text: "#314351ff",
      title: "#131b24ff",
      subtitle: "#556575ff",
      disabled: {
        text: "#7e8e9eff"
      },
      action: {
        text: "#304ddbff"
      },
      selected: {
        text: "#ffffffff",
        title: "#ffffffff",
        subtitle: "#d1e8ffff",
        background: "#304ddbff"
      },
      icon: {
        default: "#314351ff",
        hover: "#253642ff"
      },
      highlighted: {
        text: "#131b24ff",
        subtitle: "#405261ff",
        background: "#ebf5ffff"
      },
      multiple: {
        highlighted: {
          text: "#253642ff"
        }
      }
    },
    selectedBadge: {
      border: "#abb9c7ff",
      hover: "#304ddbff",
      disabled: {
        border: "#abb9c7ff",
        shadow: "#c8d3deff",
        background: "#f9fafaff"
      }
    },
    divider: "#dfe6ebff",
    groupLabel: "#7e8e9eff",
    togglers: {
      navLink: {
        text: "#9ecbffff",
        background: "#1c2674ff",
        attention: "#ff5caaff"
      },
      splitButton: {
        shadowDisabled: "#7e8e9eff",
        yellow: {
          text: {
            default: "#7a4518ff",
            hover: "#573b23ff"
          },
          bg: {
            default: "#fff6e5ff",
            hover: "#ffeeccff"
          },
          border: {
            default: "#fabf5aff",
            hover: "#e09c24ff"
          },
          disabled: {
            bg: "#f9fafaff",
            text: "#abb9c7ff"
          }
        }
      },
      select: {
        shadow: "#abb9c7ff",
        text: "#405261ff",
        shadowError: "#e54a32ff",
        disabled: "#7e8e9eff"
      },
      selectArrow: {
        border: "#314351ff"
      }
    }
  }
};
export {
  f as dropList
};
